import SortColumnTable from "./sortColumnTable";

export default SortColumnTable